"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ThemeContext = require("../../core/ThemeContext");

var _Div = _interopRequireDefault(require("../div/Div"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Container = _react["default"].forwardRef(function (props, ref) {
  var context = (0, _react.useContext)(_ThemeContext.ThemeContext);
  return _react["default"].createElement(_Div["default"], _extends({
    ref: ref,
    maxW: context.grid.containerMaxWidth
  }, props));
});

Container.defaultProps = {
  w: "100%",
  m: {
    y: 0,
    x: "auto"
  },
  p: {
    y: 0,
    x: "1.5rem"
  }
};
var _default = Container;
exports["default"] = _default;